import { React } from "react";
import { Box } from "@mui/material";
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbarCustom from "examples/Navbars/DashboardNavbarCustom";
//import { loginToGetToken } from "api/api_register2FA";
import "./Style.scss";
import PropTypes from "prop-types";
import intro2FAImg from "../../../assets/images/intro2FAImg.png";

function Register2FAIntroduce({ setOpenIntroduce, setOpenReEnterPassword }) {
  const PageReEnterPassWord = async () => {
    setOpenIntroduce((prev) => !prev);
    setOpenReEnterPassword((prev) => !prev);
  };
  return (
    <Box width={470} className="form-container" textAlign="justify">
      <p className="fs-20 fw-700 gray-100">Xác thực 2 bước</p>
      <Box>
        <p className="w-100 fs-14">Hầu hết mọi người chỉ có lớp mật khẩu để bảo vệ tài khoản.</p>
        <p className="w-100 fs-14">
          Với xác thực 2 bước, nếu kẻ xấu tấn công thông qua lớp mật khẩu, chúng ta vẫn có điện
          thoại hoặc khóa bảo mật để đăng nhập vào tài khoản.
        </p>
        <p className="w-100 fs-14">
          Với xác thực 2 bước, tài khoản sẽ được bảo vệ bằng những gì người dùng biết (mật khẩu) và
          những gì người dùng có (điện thoại hoặc khóa bảo mật)
        </p>
      </Box>
      <img src={intro2FAImg} alt="intro2FA" className="intro-image" />
      <Box>
        <Box className="fs-14 fw-700 w-100 gray-100">Cách thiết lập</Box>
        <p className="w-100 fs-14">1. Chọn một phương pháp để xác nhận mã qua điện thoại</p>
        <p className="w-100 fs-14">
          2. Xác thực xem phương thức đã được chọn có hoạt động hay không khi hệ thống gửi mã OTP.
        </p>
      </Box>
      <Box
        className="centered fs-14"
        style={{
          marginTop: "20px",
          width: "40%",
          height: "36px",
          background: "var(--blue-blue-100)",
          borderRadius: "6px",
          color: "white",
          cursor: "pointer",
        }}
        role="button"
        tabIndex="0"
        onClick={PageReEnterPassWord}
        onKeyDown={() => {}}
      >
        Tiếp theo
      </Box>
    </Box>
  );
}

Register2FAIntroduce.defaultProps = {
  setOpenIntroduce: () => {},
  setOpenReEnterPassword: () => {},
};

Register2FAIntroduce.propTypes = {
  setOpenIntroduce: PropTypes.func,
  setOpenReEnterPassword: PropTypes.func,
};

export default Register2FAIntroduce;
